import Restful from '../utils/restful.js'
const project = 'sci/'

// 操作日志相关
const operation = new Restful(project, 'operation/log')
export default operation
